import React from "react";
import CardTable from "./CardTable";

const App = () => <CardTable />;

export default App;
